import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import moment from 'moment-timezone';
/**
 * Widget + date defaults for "IDG Components" print (dashboard preconfig + IDG render dialog).
 * Matches dashboard `printPreconfigBuilders` IDG Components option (14 days back through today).
 */

const idgComponentsWidgetSelection = {
  ClearScripts: {
    view: 'Active',
    notesMode: 'dateRange'
  },
  Measures: {
    view: 'Graphs',
    notesMode: 'dateRange'
  },
  Bereavement: true,
  CarePlanProblems: {
    view: 'Listing',
    notesMode: 'dateRange'
  },
  CarePlanFrequency: {
    notesMode: 'dateRange'
  },
  CompletedForms: {
    view: 'Listing',
    notesMode: 'dateRange',
    filter: 'idgOnly'
  },
  Manifest: {
    view: 'Listing',
    filter: 'idgOnly'
  },
  ProgressNotes: {
    view: 'Both',
    filter: 'idgOnly'
  }
};
/**
 * Build a print config for the IDG Components widget.
 *
 * When `dates` is supplied the config uses those exact dates (e.g. when
 * re-generating an existing IDGv2 manifest whose meeting period is already
 * known). Without `dates` it falls back to the default 14-day window ending
 * today, which matches the dashboard "IDG Components" preconfig option.
 */

export const buildIdgComponentsPreconfig = dates => {
  var _dates$fromDate, _dates$toDate;

  return _objectSpread(_objectSpread({}, idgComponentsWidgetSelection), {}, {
    fromDate: (_dates$fromDate = dates === null || dates === void 0 ? void 0 : dates.fromDate) !== null && _dates$fromDate !== void 0 ? _dates$fromDate : moment().subtract(14, 'days').format('YYYY-MM-DD'),
    toDate: (_dates$toDate = dates === null || dates === void 0 ? void 0 : dates.toDate) !== null && _dates$toDate !== void 0 ? _dates$toDate : moment().format('YYYY-MM-DD')
  });
};